import actions from './actions';

const initState = {
  callback: {
    tokenClaims: {},
    tenants: [],
    accounts: [],
  },
};

export default function appReducer(state = initState, action) {
  switch (action.type) {
    case actions.ADD_CALLBACK:
      return {
        ...state,
        callback: action.callback,
      };

    default:
      return state;
  }
}
